import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from 'app/core/auth/auth.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  /**
   * Constructor
   */
  constructor(private _authService: AuthService) {}

  /**
   * Intercept
   *
   * @param req
   * @param next
   */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Clone the request object

    let newReq = req.clone();

      const baseUrl = environment.api;

      // ONLY modify requests originating from app services (based on URL path or other criteria)
      if (req.url.startsWith('/api') || req.url.startsWith('api')) {
        // Prepend base URL to the request
        newReq = newReq.clone({
          url: `${baseUrl}${req.url.startsWith('/') ? '' : '/'}${req.url}`
        });
      }

    // Add custom Allowed-Headers header
    newReq = newReq.clone({
      headers: newReq.headers.set('Allowed-Headers', '*') // Setting Allowed-Headers to '*'
    });

    // Request
    //
    // If the access token didn't expire, add the Authorization header.
    // We won't add the Authorization header if the access token expired.
    // This will force the server to return a "401 Unauthorized" response
    // for the protected API routes which our response interceptor will
    // catch and delete the access token from the local storage while logging
    // the user out from the app.
    if (this._authService.access_token) {
      newReq = newReq.clone({
        headers: newReq.headers.set('Authorization', 'Bearer ' + this._authService.access_token)
      });

      if (newReq.method === 'POST') {
        // Clone the request with a modified body
        const modifiedBody = {
          ...newReq.body, // Retain existing body properties
          id_funcionario: JSON.parse(localStorage.getItem('user'))?.id_funcionario
        };

        // Update the request with the modified body
        newReq = newReq.clone({
          body: modifiedBody
        });
      }
    }

    // Response
    return next.handle(newReq).pipe(
      catchError(error => {
        // Catch "401 Unauthorized" responses
        if (error instanceof HttpErrorResponse && error.status === 401) {
          // Sign out
          this._authService.signInUsingToken();

          // Reload the app
          location.reload();
        }

        return throwError(error);
      })
    );
  }
}
